import React from 'react';
import { Table } from 'reactstrap';
import JobResourceOverrideSpecifics from './JobResourceOverrideSpecifics';

export default class ResourceApplicationUserGroupDisplayTable
    extends React.Component
{
    getJobResourceValue = (jobResource) => {
        const { dayName } = this.props;

        if (!jobResource || !dayName) {
            return null;
        }

        return jobResource[dayName.toLowerCase()];
    };

    render() {
        const { filteredJobResources, applicationUserGroups } = this.props;

        return (
            <Table
                size="sm"
                className="resource-application-user-group-display-table"
            >
                <thead>
                    <tr>
                        <th>User Group</th>
                        <th># of Resources</th>
                        <th>Overrides</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredJobResources.map((mjr, i) => {
                        const applicationUserGroup = applicationUserGroups.find(
                            (aug) => aug.id == mjr.applicationUserGroupId
                        );

                        if (!applicationUserGroup) {
                            return null;
                        }

                        let resourceCount = this.getJobResourceValue(mjr);

                        if (resourceCount <= 0) {
                            return null;
                        }

                        return (
                            <tr key={`readOnlyJobAugResource-${i}`}>
                                <td>{applicationUserGroup.groupName}</td>
                                <td>{resourceCount}</td>
                                <td>
                                    <JobResourceOverrideSpecifics
                                        jobResourceOverrides={
                                            mjr.jobResourceOverrides
                                        }
                                        arcGisLocations={
                                            this.props.arcGisLocations
                                        }
                                        resourceLabel={
                                            applicationUserGroup.groupName
                                        }
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }
}
